<template>
    <div class="fill-height d-flex align-center justify-center login-back" >

        <div style="position: absolute; left: 0; top: 0" class="ma-2">
            <a :href="apkURL" target="_blank" style="text-decoration: none">
                <v-btn
                        icon
                        color="green"
                >
                    <v-icon>mdi-android</v-icon>
                </v-btn>
            </a>
            <a :href="hrApkURL" target="_blank" style="text-decoration: none">
                <v-btn
                        icon
                        color="orange"
                >
                    <v-icon>mdi-android</v-icon>
                </v-btn>
            </a>
        </div>

        <div class="d-flex flex-column align-center" style="width: 350px">
            <div class="pb-3">
                <img alt="logo" src="../../../public/images/logo_light.svg" width="100px"/>
            </div>
            <div class="pa-2" style="width: 100%">
                <div class="pb-2">
                    <v-text-field
                            solo
                            dense
                            prepend-inner-icon="mdi-account"
                            placeholder="Username"
                            hide-details="auto"
                            :disabled="loggingIn"
                            v-model="username"
                            @keydown.enter="password && password.length ? (username && username.length ? login() : $refs.password.focus()) : $refs.password.focus()"
                            ref="username"
                    />
                </div>
                <div class="pb-2">
                    <v-text-field
                            solo
                            dense
                            prepend-inner-icon="mdi-key-variant"
                            placeholder="password"
                            hide-details="auto"
                            :disabled="loggingIn"
                            v-model="password"
                            type="password"
                            ref="password"
                            @keydown.enter="username && username.length ? (password && password.length ? login() : $refs.username.focus()) : $refs.username.focus()"
                    />
                </div>

                <div class="text-right">
                    <v-btn
                            elevation="2"
                            outlined
                            color="white"
                            small
                            :loading="loggingIn"
                            :disabled="loggingIn"
                            @click="username && username.length && password && password.length ? login() : $snack.error('Username and password required.')"
                    >
                        Login
                    </v-btn>
                </div>

                <div class="caption font-weight-bold amber--text text-center" v-if="!!loginError">
                    {{loginError}}
                </div>


            </div>
        </div>
    </div>
</template>

<script>


import {getServerAddress, initializeRequestAuth} from "../../core/request";
import {mapActions} from "vuex";
import {initSocket} from "../../core/socket";

export default {
    components: {},
    props: {},
    data() {
        return {
            username: null,
            password: null,
            loginError: null,
            loggingIn: false
        }
    },
    watch: {
        username() {this.loginError = null},
        password() {this.loginError = null}
    },
    methods: {
        ...mapActions(['setLogin']),
        async login() {
            try {
                this.loggingIn = true
                let loginData = await this.$newReq('POST', `login`, {username: this.username, password: this.password})
                if (!loginData.status)
                    this.loginError = 'Invalid Credentials'
                else {
                    // Init Security On Requests
                    initializeRequestAuth(loginData.payload.token)
                    initSocket(loginData.payload.socketSrv)
                    this.setLogin(loginData.payload.userID);
                }
            } catch (e) {
                this.loginError = 'Server Error'
                console.log(e)
            } finally {
                this.loggingIn = false
            }
        }
    },
    computed: {
        apkURL() {
            return `${getServerAddress()}/apk/Salom_Scan.apk`
        },
        hrApkURL() {
            return `${getServerAddress()}/hrapk/Salom_HR.apk`
        }
    },
}
</script>

<style scoped>
    .login-back {
        background-image: url("../../../public/images/background-lower.jpg");
        background-position: center;
        background-size: cover;
    }
</style>